import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../components/common/AppNavbar";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Source+Serif+4:ital,wght@0,400;0,500;1,400&display=swap');

  .tbs-page {
    background: #FAFAF8;
    min-height: 100vh;
    font-family: 'Source Serif 4', Georgia, serif;
    color: #1C1C1C;
  }

  .tbs-hero-bar {
    background: linear-gradient(90deg, #7B2D00 0%, #B84500 60%, #C8720A 100%);
    height: 5px;
    width: 100%;
  }

  .tbs-header h2 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.3;
    color: #1C1C1C;
  }

  .tbs-badge-upcoming {
    background: #E8F5E9 !important;
    color: #2E7D32 !important;
    border: 1px solid #A5D6A7;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 3px;
  }

  .tbs-dateline {
    font-size: 0.9rem;
    color: #888;
    letter-spacing: 0.5px;
    border-left: 3px solid #C8720A;
    padding-left: 10px;
    margin-top: 8px;
    display: inline-block;
  }

  .tbs-divider {
    border: none;
    border-top: 1px solid #E8E0D0;
    margin: 28px 0;
  }

  .tbs-video-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  }

  .tbs-body p {
    font-size: 1.05rem;
    line-height: 1.85;
    color: #333;
    margin-bottom: 18px;
  }

  .tbs-section-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: #1C1C1C;
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 18px;
  }

  .tbs-section-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #B84500, #C8720A);
    border-radius: 2px;
  }

  .tbs-card {
    border: 1px solid #E8E0D0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
    background: #fff !important;
  }

  .tbs-card .card-body {
    padding: 28px 32px;
  }

  .tbs-card h3,
  .tbs-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1C1C1C;
    margin-bottom: 14px;
  }

  .tbs-card h5 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1rem;
    font-weight: 600;
    color: #B84500;
    margin-bottom: 10px;
  }

  .tbs-card ul, .tbs-card ol {
    padding-left: 20px;
    color: #444;
    font-size: 0.97rem;
    line-height: 1.8;
  }

  .tbs-card p {
    font-size: 0.97rem;
    line-height: 1.8;
    color: #444;
    margin-bottom: 10px;
  }

  /* Event Info Banner */
  .tbs-event-banner {
    background: linear-gradient(135deg, #1C1C1C 0%, #2E1A06 100%);
    border-radius: 8px;
    padding: 28px 32px;
    color: #fff;
    margin-bottom: 28px;
  }

  .tbs-event-banner .event-label {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #F0A060;
    margin-bottom: 14px;
    font-weight: 600;
  }

  .tbs-event-banner .event-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #F0C040;
    margin-bottom: 16px;
    font-style: italic;
  }

  .tbs-event-banner .event-detail {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 0.95rem;
    color: rgba(255,255,255,0.8);
  }

  .tbs-event-banner .event-detail-icon {
    color: #F0A060;
    font-size: 1rem;
    margin-top: 1px;
    flex-shrink: 0;
  }

  /* Performers Grid */
  .tbs-performers {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }

  .tbs-performer-chip {
    background: #FFF3E0;
    border: 1px solid #F0A060;
    color: #B84500;
    border-radius: 4px;
    padding: 6px 14px;
    font-size: 0.88rem;
    font-weight: 500;
  }

  /* Ticket Card */
  .tbs-ticket-card {
    border: 1px solid #E8E0D0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
    background: #fff !important;
  }

  .tbs-ticket-card .card-body {
    padding: 28px 32px;
  }

  .tbs-ticket-card h3 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1C1C1C;
    margin-bottom: 20px;
  }

  .tbs-ticket-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #F0EAE0;
    font-size: 0.97rem;
    color: #333;
  }

  .tbs-ticket-row:last-child { border-bottom: none; }

  .tbs-ticket-price {
    font-weight: 700;
    color: #B84500;
    font-size: 1rem;
  }

  .tbs-ticket-note {
    font-size: 0.82rem;
    color: #888;
  }

  .tbs-location-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .tbs-location-list li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #F0EAE0;
    font-size: 0.95rem;
    color: #444;
  }

  .tbs-location-list li:last-child { border-bottom: none; }

  .tbs-location-num {
    background: #B84500;
    color: #fff;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 700;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .tbs-instagram-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(90deg, #B84500, #C8720A);
    color: #fff;
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 0.85rem;
    font-weight: 600;
    text-decoration: none;
    margin-top: 16px;
    transition: opacity 0.2s;
  }

  .tbs-instagram-link:hover { opacity: 0.88; color: #fff; }

  .tbs-closing-bold {
    font-size: 1.05rem;
    font-weight: 600;
    color: #B84500;
    border-left: 3px solid #C8720A;
    padding-left: 16px;
    font-style: italic;
  }

  .tbs-about-card {
    background: linear-gradient(135deg, #1C1C1C 0%, #2E1A06 100%) !important;
    border: none !important;
    border-radius: 8px !important;
  }

  .tbs-about-card .card-body { padding: 28px 32px; }

  .tbs-about-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.2rem;
    color: #F0C040;
    margin-bottom: 8px;
  }

  .tbs-about-card .about-link {
    color: #F0A060;
    font-size: 0.88rem;
    font-weight: 600;
    text-decoration: none;
  }

  .tbs-about-card .about-link:hover { color: #fff; }

  .tbs-about-card p {
    color: rgba(255,255,255,0.7);
    font-size: 0.95rem;
    line-height: 1.75;
    margin-bottom: 14px;
  }

  @media (max-width: 768px) {
    .tbs-header h2 { font-size: 1.5rem; }
    .tbs-card .card-body,
    .tbs-ticket-card .card-body,
    .tbs-about-card .card-body,
    .tbs-event-banner { padding: 20px; }
  }
`;

const performers = [
  "Wolveraas",
  "Taal",
  "Izzat",
  "Michigan Masala",
  "Wolverine Bhangra",
  "Sahana Music and Dance",
  "Spartan Sur",
];

const tickets = [
  { label: "Student Ticket", note: "Starting at", price: "$13" },
  { label: "Non-Student Ticket", note: "", price: "$20" },
  { label: "After Party Ticket", note: "", price: "$15" },
  { label: "Show + After Party Package", note: "Best value", price: "$25" },
];

const locations = [
  { name: "Mason Hall", note: "Available from March 30" },
  { name: "North Campus Location", note: "Coming soon" },
  { name: "At the Door", note: "Day of show" },
];

function MichiganSahanaThatBrownShow() {
  return (
    <>
      <style>{styles}</style>
      <AppNavbar />

      <div className="tbs-page">
        <div className="tbs-hero-bar" />

        <div className="container py-5">
          {/* Header */}
          <div className="tbs-header mb-4">
            <span className="badge tbs-badge-upcoming mb-3">
              Upcoming Event
            </span>
            <h2>
              That Brown Show: Into Pandora — Michigan Sahana's Annual Flagship
              Production
            </h2>
            <div className="tbs-dateline">
              April 11, 2026 — Michigan Theater, Ann Arbor, MI
            </div>
          </div>

          <hr className="tbs-divider" />

          {/* Video */}
          {/* <div className="mb-5">
            <div className="tbs-video-wrapper ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/55ICsiDzqSI"
                title="Michigan Sahana — That Brown Show"
                allowFullScreen
              />
            </div>
            <p className="text-muted mt-2" style={{ fontSize: "0.82rem" }}>
              Watch past performances on the{" "}
              <a
                href="https://www.youtube.com/@MichiganSahana"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#B84500" }}
              >
                Michigan Sahana YouTube channel
              </a>
            </p>
          </div> */}

          {/* Event Banner */}
          <div className="tbs-event-banner mb-5">
            <div className="event-label">Event Details</div>
            <div className="event-title">"That Brown Show: Into Pandora"</div>
            <div className="event-detail">
              <span className="event-detail-icon">📍</span>
              <span>Michigan Theater, Ann Arbor, MI</span>
            </div>
            <div className="event-detail">
              <span className="event-detail-icon">📅</span>
              <span>Saturday, April 11, 2026</span>
            </div>
            <div className="event-detail">
              <span className="event-detail-icon">🕖</span>
              <span>7:00 PM – 9:00 PM</span>
            </div>
          </div>

          {/* Intro */}
          <div className="tbs-body mb-4">
            <p>
              Bharat Abroad is pleased to highlight{" "}
              <strong>
                <em>That Brown Show: Into Pandora</em>
              </strong>
              , Michigan Sahana's annual flagship production and a defining
              expression of South Asian arts within the global diaspora.
            </p>
            <p>
              This year's showcase invites audiences on a visually compelling
              and culturally rich journey <em>Into Pandora</em>, bringing
              together tradition, creativity, and contemporary expression
              through music and dance.
            </p>
          </div>

          {/* About Michigan Sahana */}
          <div className="mb-4">
            <h3 className="tbs-section-title">About Michigan Sahana</h3>
            <div className="tbs-body">
              <p>
                Michigan Sahana is a student-led performing arts organization at
                the University of Michigan, dedicated to promoting Indian /
                Bharat classical music and dance while embracing innovation,
                collaboration, and cross-genre creativity.
              </p>
              <p>
                Originally established as ICMD (Indian Classical Music &amp;
                Dance) in Winter 2003, Michigan Sahana today stands as a
                cultural cornerstone for students passionate about South Asian
                arts. Through performances, annual productions, and community
                engagement, the organization serves as a vital artistic home on
                campus.
              </p>
            </div>
          </div>

          {/* What to Expect */}
          <div className="card tbs-card mb-4">
            <div className="card-body">
              <h3>What to Expect</h3>
              <p>
                From classical and fusion choreography to high-energy folk and
                contemporary expressions, <em>That Brown Show</em> is a
                celebration of South Asian artistry, student talent, and
                cultural pride. The evening will feature vibrant performances
                by:
              </p>
              <div className="tbs-performers">
                {performers.map((p) => (
                  <span className="tbs-performer-chip" key={p}>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Cultural Significance */}
          <div className="mb-4">
            <h3 className="tbs-section-title">
              Celebrating South Asian Heritage Abroad
            </h3>
            <div className="tbs-body">
              <p>
                Michigan Sahana's <em>That Brown Show</em> exemplifies how
                students with Bharat roots continue to preserve, reimagine, and
                celebrate South Asian cultural heritage on global platforms.
                Events like these play a vital role in strengthening cultural
                continuity, fostering artistic expression, and nurturing
                community connections far from home.
              </p>
              <p>
                Bharat Abroad is honored to support and share this vibrant
                student-led showcase and encourages the community to join in
                celebrating the spirit of South Asian arts in Michigan.
              </p>
            </div>
          </div>

          {/* Tickets */}
          <div className="card tbs-ticket-card mb-4">
            <div className="card-body">
              <h3>
                Ticket Information{" "}
                <span
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 400,
                    color: "#888",
                    fontStyle: "italic",
                  }}
                >
                  — Support our students with Bharat roots
                </span>
              </h3>

              <h5
                style={{
                  fontFamily: "'Playfair Display', serif",
                  color: "#B84500",
                  fontSize: "0.85rem",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  marginBottom: "4px",
                }}
              >
                Pricing
              </h5>
              {tickets.map((t) => (
                <div className="tbs-ticket-row" key={t.label}>
                  <div>
                    <span>{t.label}</span>
                    {t.note && (
                      <span className="tbs-ticket-note ms-2">({t.note})</span>
                    )}
                  </div>
                  <span className="tbs-ticket-price">{t.price}</span>
                </div>
              ))}

              <h5
                className="mt-4"
                style={{
                  fontFamily: "'Playfair Display', serif",
                  color: "#B84500",
                  fontSize: "0.85rem",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  marginBottom: "10px",
                }}
              >
                Ticket Sales Locations
              </h5>
              <ul className="tbs-location-list">
                {locations.map((l, i) => (
                  <li key={l.name}>
                    <span className="tbs-location-num">{i + 1}</span>
                    <div>
                      <strong>{l.name}</strong>
                      <div className="tbs-ticket-note">{l.note}</div>
                    </div>
                  </li>
                ))}
              </ul>

              <a
                href="https://www.instagram.com/michigansahana"
                target="_blank"
                rel="noopener noreferrer"
                className="tbs-instagram-link"
              >
                📸 @michigansahana — More ticket details on Instagram
              </a>
            </div>
          </div>

          {/* Closing */}
          <div className="tbs-body mb-5">
            <p className="tbs-closing-bold">
              Mark your calendars for April 11th — Michigan Sahana's{" "}
              <em>That Brown Show: Into Pandora</em> promises to be an
              unforgettable evening of South Asian arts, heritage, and
              community.
            </p>
          </div>

          {/* About Bharat Abroad */}
          <div className="card srk-about-card mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                {/* Left Image */}
                <div className="col-md-3 text-center mb-3 mb-md-0">
                  <img
                    src="https://ayg.s3.us-east-2.amazonaws.com/BA_whatsapp.png"
                    alt="Bharat Abroad"
                    className="img-fluid rounded"
                    style={{ height: "auto" }}
                  />
                </div>

                {/* Right Content */}
                <div className="col-md-9">
                  <h4>About Bharat Abroad</h4>

                  <p className="mb-2">
                    <a
                      href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="about-link"
                    >
                      www.bharatabroad.com
                    </a>{" "}
                    — Subscribe with us / Join our WhatsApp Community
                  </p>

                  <p className="mb-0">
                    Bharat Abroad is a community-focused initiative dedicated to
                    highlighting and strengthening Bharat's cultural and
                    spiritual presence across the global diaspora through
                    storytelling, event engagement, and collaboration with
                    nonresident Bharatiya organizations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MichiganSahanaThatBrownShow;
